<template>
  <div>
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>提成比例设置</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row style="padding: 15px">
      <el-row class="main">
        <!--<el-row style="text-align: left">-->
          <!--<el-select v-model="typeValue" placeholder="请选择用户类型">-->
            <!--<el-option label="用户" value="1"></el-option>-->
            <!--<el-option label="普通会员" value="2"></el-option>-->
            <!--<el-option label="大师会员" value="3"></el-option>-->
            <!--<el-option label="弟子" value="4"></el-option>-->
          <!--</el-select>-->
        <!--</el-row>-->
        <!--<el-row style="text-align: left;margin-top: 10px">-->
          <!--<span>一级分销比例</span>-->
          <!--<el-input type="number" clearable v-model="oneValue" auto-complete="off" placeholder="请输入一级分销比例" required-->
                    <!--style="width: 180px"></el-input>-->
          <!--<span style="margin-left: 15px">二级分销比例</span>-->
          <!--<el-input type="number" clearable v-model="twoValue" auto-complete="off" placeholder="请输入二级分销比例" required-->
                    <!--style="width: 180px"></el-input>-->
          <!--<el-button type="primary" @click="submit('editdata')" style="margin-left: 15px">确 定</el-button>-->
        <!--</el-row>-->
        <el-col :xs="24" :sm="12" :md="6" :lg="6" style="margin-bottom: 20px;padding: 10px;box-sizing: border-box" v-for="(item,index) in listData" :key="index">
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>{{item.remarks}}</span>
            </div>
            <div style="text-align:left;display: flex;align-items: center">
              <div style="width: 110px;text-align: left;line-height: 30px;">一级比例:</div>
              <el-input v-model="item.tc_level1" placeholder="请输入一级分销比例" type="number" style="width: 60%" min="0">></el-input>
              <span style="margin-left: 5px">%</span>
            </div>
            <div style="text-align:left;display: flex;margin-top: 10px;align-items: center">
              <div style="width: 110px;text-align: left;line-height: 30px">	二级比例:</div>
              <el-input v-model="item.tc_level2" placeholder="请输入二级分销比例" type="number" style="width: 60%" min="0"></el-input>
              <span style="margin-left: 5px">%</span>
            </div>
         <div style="text-align:left;display: flex;margin-top: 10px;align-items: center"v-if="item.price>0">
              <div style="width: 110px;text-align: left;line-height: 30px">	价格:</div>
              <el-input v-model="item.price" placeholder="请输入二级分销比例" type="number" style="width: 60%" min="0"></el-input>
              <span style="margin-left: 5px"></span>
            </div>
            <div style="font-size: 14px;margin-top: 20px">
              <el-button type="primary" @click="submit(item)">保存</el-button>
            </div>
          </el-card>
        </el-col>

      </el-row>
    </el-row>


    <template><span v-loading.fullscreen.lock="fullscreenLoading"></span></template>

  </div>
</template>

<script>

  export default {
    name: "FinanceCommissionSet",
    mounted() {
      this.getstart()
    },
    data() {
      return {
        oneValue: '',
        twoValue: '',
        formLabelWidth: '150px',
        fullscreenLoading: false,
        typeValue:'',
        listData:[]
      }
    },
    methods: {
      getstart() {
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.listTcLevel
        ).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          var qtotal = response.data.Total
          if (qcode == 200) {
            thi.listData=qdata
            // thi.oneValue = qdata.yiji
            // thi.twoValue = qdata.erji
          }
          thi.fullscreenLoading = false
        }).catch(function (error) {
          console.log(error)
        });
      },
      //提交
      submit(item) {
        let thi = this
        thi.fullscreenLoading = true
        // const por={
        //   yiji:thi.oneValue,
        //   erji:thi.twoValue
        // }
        console.log(item)
        thi.$http.post(global.posturl.host + global.posturl.setTcLevel,item).then(function (response) {
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          if (qcode == 200) {
            thi.$message({
              type: 'success',
              message: qmsg
            });
          } else {
            thi.$message({
              type: 'warning',
              message: qmsg
            });
          }
          thi.getstart()
        }).catch(function (error) {
          console.log(error)
        });
      },
      typeChange(type){
        switch (type) {
          case 1:
            return "用户";
          case 2:
            return "普通会员";
          case 3:
            return "大师会员";
          case 4:
            return "弟子";
          default:
            return null;
        }
      }
    }
  }
</script>

<style scoped>
  .admin-body {
    /*background-color: white;*/
    width: 100%;
  }

  .main {
    background-color: white;
    min-height: 500px;
    padding: 10px;
    border: #EDEDED 1px solid;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/page/finance/FinanceCommissionSet.vue